module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "mt-modal mt-zindex--middle",
    class: ['mt-modal--' + _vm.size],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "mt-modal__dialog"
  }, [_c('header', {
    staticClass: "mt-modal__header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.closeVisible) ? _c('mt-button', {
    staticClass: "mt-modal__close",
    attrs: {
      "size": "small",
      "width": "10",
      "type": "subtle"
    },
    on: {
      "click": function($event) {
        _vm.$emit('update:visible', !_vm.visible)
      }
    }
  }, [_c('mt-icon', {
    attrs: {
      "iconName": "close",
      "hover": false
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-modal__body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.hasSlotFooter) ? _c('footer', {
    staticClass: "mt-modal__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419d4467","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/modal/Modal.vue
// module id = 3Z+W
// module chunks = 0